import React from 'react';
import ChartRenderer from '../components/ChartRenderer';
import './ChartModal.css';

const ChartModal = ({ chartData, onClose, handleBarClick }) => {
  if (!chartData) return null;

  const { type, data, sampleSizes, labelTypes, asPercentages, asMixedSentiment, showDataLabels } = chartData;

  return (
    <div className="chart-modal-overlay">
      <div className="chart-modal-content">
        <button className="chart-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2>{type} Chart</h2>

        {/* Render the enlarged chart */}
        <ChartRenderer
          labelType={type}
          chartData={{ [type]: data }}
          sampleSizes={sampleSizes}
          labelTypes={labelTypes}
          asPercentages={asPercentages}
          asMixedSentiment={asMixedSentiment}
          showDataLabels={showDataLabels}
          onBarClick={handleBarClick}
        />
      </div>
    </div>
  );
};

export default ChartModal;
